export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6251.0fb5ec27.jpg";